/* =================== BLOG HOME =================== */
$(function () {
  $(".carrosel-sobre-home").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: false,
    adaptiveHeight: true,
    autoplaySpeed: 3000,
    arrows: true,
  });
});
